/* La Florentina customer events for the Customer Events custom pixel "LF – Google Ads leads". Deferred, no dependencies.
   Payloads stay empty: the pixel reads only the event name and the page (no personal data). */
(function () {
  'use strict';

  function publish(name) {
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, {});
    } catch (e) {
      /* analytics must never break navigation */
    }
  }

  /* "Clic en WhatsApp": any wa.me link to the store number from the theme settings (floating button, B2B landing,
     home block, contact, 404, quote success message). All of them open in a new tab, so the page stays alive
     while the pixel sends the conversion. */
  var script = document.currentScript;
  var number = script ? (script.getAttribute('data-whatsapp') || '').replace(/\D/g, '') : '';
  if (!number) return;
  var selector = 'a[href*="wa.me/' + number + '"]';

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest && event.target.closest(selector);
    if (link) publish('lf:whatsapp_click');
  });
})();
